import React, { useEffect, useState, useContext } from "react";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { AuthContext } from "../../Routes/AuthProvider"
import { getAutoStation } from "../../Services/TrainApi"
import { RaiseTrainEnquiry } from "../../Services/EnquiryApi"

const RailSearch = () => {
  const { name, userName, corporateId } = useContext(AuthContext);
  const [fromStationSuggestions, setFromStationSuggestions] = useState([]);
  const [toStationSuggestions, setToStationSuggestions] = useState([]);
  const [errors, setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [enquiryMessage, setEnquiryMessage] = useState("");
  const [enquiryStatus, setEnquiryStatus] = useState(false);
  const [travelTypeMode, setTravelTypeMode] = useState("1");
  const [trainSearchParams, setTrainSearchParams] = useState({
    fromStation: "NDLS",
    toStation: "PRYJ",
    travelDate: "",
    journeyClass: "All",
    journeyQuota: "GN",
    adult: 1,
    child: 0,
    infant: 0,
  });

  const swapMainDestination = (e) => {
    e.preventDefault();

    setTrainSearchParams((prev) => ({
      ...prev,
      fromStation: prev.toStation,
      toStation: prev.fromStation,
    }));
  };


  // FETCH From SUGGESTIONS
  const handleFromStation = async (e) => {
    const value = e.target.value;
    if (value.length > 1) {
      const data = await getAutoStation(value);
      console.log("data", data);
      setFromStationSuggestions(data?.stationList || []);
    } else {
      setFromStationSuggestions([]);
    }
  };


  // FETCH To SUGGESTIONS
  const handleToStation = async (e) => {
    const value = e.target.value;
    if (value.length > 1) {
      const data = await getAutoStation(value);
      setToStationSuggestions(data?.stationList || []);
    } else {
      setToStationSuggestions([]);
    }
  };

  // SELECT PICKUP CITY
  const selectFromStation = (station) => {
    const location = `${station.stationName} (${station.stationCode})`;
    setTrainSearchParams((prev) => ({
      ...prev,
      fromStation: location,
    }));

    setFromStationSuggestions([]);
  };

  // SELECT DROP CITY
  const selectToStation = (station) => {
    const location = `${station.stationName} (${station.stationCode})`;

    setTrainSearchParams((prev) => ({
      ...prev,
      toStation: location,
    }));

    setToStationSuggestions([]);
  };

  // HANDLE INPUT CHANGES
  const handleChange = (e) => {
    const { name, value } = e.target;
    setTrainSearchParams((prev) => ({ ...prev, [name]: value }));
  };


  useEffect(() => {
    $("#departureDate").datepicker({
      dateFormat: "dd/mm/yy",
      appendTo: "#dateDisplay",
      minDate: 0,
      maxDate: "+4m", // ✅ limit 4 months ahead
      showAnim: "fadeIn",
      beforeShow: function (input, inst) {
        setTimeout(() => {
          const offset = $("#dateDisplay").offset();
          const height = $("#dateDisplay").outerHeight();
          $(inst.dpDiv).css({
            top: offset.top + height + "px",
            left: offset.left + "px",
          });
        }, 0);
      },
      onSelect: function (fromDate) {
        const date = $(this).datepicker("getDate");
        const day = ("0" + date.getDate()).slice(-2);
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();
        const dayName = date.toLocaleDateString("default", { weekday: "long" });

        $("#dep_dayNum").text(day);
        $("#dep_monthYear").text(`${month}-${year}`);
        $("#dep_dayName").text(dayName);

        setTrainSearchParams(prev => ({
          ...prev,
          travelDate: fromDate
        }));
      },
    });
  }, []);

  const handleRaiseRequest = async () => {
    let newErrors = {};

    if (!trainSearchParams.fromStation.trim()) {
      newErrors.from = "Please select a From Station";
    }
    if (!trainSearchParams.toStation.trim()) {
      newErrors.to = "Please select a To station";
    }

    if (!trainSearchParams.travelDate.trim()) {
      newErrors.FromDate = "Please select Travel Date";
    } else {
      // const datePattern = /^\d{2}\/\d{2}\/\d{4}$/;
      // if (!datePattern.test(cabSearchParams.fromDate)) {
      //   newErrors.date = "Date must be in dd/mm/yyyy format";
      // }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});

    const emulateCorporateCode = localStorage.getItem("selectedCorporateCode");
    const userId = emulateCorporateCode || corporateId;
    const CorporateName = localStorage.getItem("selectedCorporateName");
    const requestBody = {
      TravelType: travelTypeMode,
      From: trainSearchParams.fromStation,
      To: trainSearchParams.toStation,
      TravelDate: trainSearchParams.travelDate,
      Class: trainSearchParams.journeyClass,
      Quota: trainSearchParams.journeyQuota,
      noOfAdult: trainSearchParams.adult,
      noOfChild: trainSearchParams.child,
      noOfInfant: trainSearchParams.infant,
      CompanyId: userId,
      OrganizationName: CorporateName,
      CreatedBy: userName
    };

    try {
      const result = await RaiseTrainEnquiry(requestBody);
      if (result.success) {
        setEnquiryMessage(result.message)
        setEnquiryStatus(true);
      }
      else {
        setEnquiryMessage(result.message)
      }
      setShowPopup(true);
    } catch {
      alert("Failed to submit enquiry");
    }
  };



  return (
    <>
      <div className='visa_serch'>
        <div className='row'>
          <div className='col-md-6 col-lg-6'>
            <div className='d-flex'>
              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input className="form-check-input" type="radio" name="travelType" value="1"
                    checked={travelTypeMode === "1"}
                    onChange={(e) => {
                      setTravelTypeMode(e.target.value)
                    }}
                  />
                  <label className="form-check-label">Business Travel</label>
                </div>
              </div>

              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input className="form-check-input" type="radio" name="travelType" value="2"
                    checked={travelTypeMode === "2"}
                    onChange={(e) => {
                      setTravelTypeMode(e.target.value)
                    }}
                  />
                  <label className="form-check-label">Personal Travel</label>
                </div>
              </div>

              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input className="form-check-input" type="radio" name="travelType" value="3"
                    checked={travelTypeMode === "3"}
                    onChange={(e) => {
                      setTravelTypeMode(e.target.value)
                    }}
                  />
                  <label className="form-check-label">Guest Travel</label>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6 col-lg-6'>
            <div className='theme_tx'>
            </div>
          </div>
        </div>

        <div className='form_ful'>
          <div className='rail_col_1'>
            <div className='rail_icon_img'>
              <img className='rail_ic' src='/assets/images/bus/train.png' alt="flight" />
            </div>
            <div className='rail_icon'>
              <p>From Station</p>
              {/* <div className='dest_nam'>Aga</div>
              <p className='area_nm'>Uttar Pradesh</p> */}
              <input
                type="text"
                className="pick_form"
                name="fromStation"
                placeholder="Enter City.."
                value={trainSearchParams.fromStation}
                onChange={(e) => {
                  handleChange(e);           // updates state
                  handleFromStation(e);  // fetches suggestions
                }}
                autoComplete="off"
              />
              {fromStationSuggestions.length > 0 && (
                <ul className="autosuggetsList">
                  {fromStationSuggestions.map((station, index) => (
                    <li key={index} onClick={() => selectFromStation(station)}>
                      {station.stationName} - {station.stationCode}
                    </li>
                  ))}
                </ul>
              )}
              {errors.from && <p className="error_mes">{errors.from}</p>}
            </div>
            <a href="" class="swiper_bus" onClick={swapMainDestination}> <img alt="icon" src="/assets/images/swipe.png" /> </a>
          </div>
          <div className='rail_col_1'>
            <div className='rail_icon_img'>
              <img className='rail_ic' src='/assets/images/bus/train.png' alt="flight" />
            </div>
            <div className='rail_icon'>
              <p>To Station</p>
              <input
                type="text"
                className="pick_form"
                name="toStation"
                placeholder="Enter City.."
                value={trainSearchParams.toStation}
                onChange={(e) => {
                  handleChange(e);           // updates state
                  handleToStation(e);  // fetches suggestions
                }}
                autoComplete="off"
              />
              {toStationSuggestions.length > 0 && (
                <ul className="autosuggetsList">
                  {toStationSuggestions.map((station, index) => (
                    <li key={index} onClick={() => selectToStation(station)}>
                      {station.stationName} - {station.stationCode}
                    </li>
                  ))}
                </ul>
              )}
              {errors.to && <p className="error_mes">{errors.to}</p>}
            </div>
          </div>
          <div className='rail_col_1 date_bst'>
            <div className='rail_icon_img'>
              <img className='rail_ic' src='/assets/images/bus/date.png' alt="flight" />
            </div>
            <div className='rail_icon'>
              <p>Travel Date</p>
              <div
                className="dest_nam"
                id="dateDisplay"
                onClick={() => $("#departureDate").datepicker("show")}
                style={{ cursor: "pointer" }}
              >
                <span id="dep_dayNum" style={{ fontSize: "26px", fontWeight: "bold" }}>
                  DD
                </span>{" "}
                <span id="dep_monthYear" style={{ fontSize: "14px" }}>
                  MM-YY
                </span>
                <br />
                <span id="dep_dayName">
                  Day
                </span>
                <input
                  type="text"
                  id="departureDate"
                  style={{ position: "absolute", left: "-9999px" }}
                  readOnly
                />
              </div>
              {errors.FromDate && <p className="error_mes">{errors.FromDate}</p>}
            </div>
          </div>
          <div className='rail_col_1 date_bst'>
            <div className='rail_icon_img'>
              <img className='rail_ic' src='/assets/images/bus/seat.png' alt="flight" />
            </div>
            <div className='rail_icon'>
              <p>Class</p>
              <select className='rail_curncy'
                name="journeyClass"
                value={trainSearchParams.journeyClass}
                onChange={handleChange}
              >
                <option value="All">All Classes</option>
                <option value="EA">Anubhuti Class (EA)</option>
                <option value="EV">Vistadome AC (EV)</option>
                <option value="VC">Vistadome Chair Car (VC)</option>
                <option value="VS">Vistadome Non AC (VS)</option>
                <option value="1A">AC First Class (1A)</option>
                <option value="EC">Executive Class (EC)</option>
                <option value="2A">AC Second Class (2A)</option>
                <option value="FC">First Class (FC)</option>
                <option value="3A">AC Third Class (3A)</option>
                <option value="3E">AC Economy Class (3E)</option>
                <option value="SL">Sleeper Class (SL)</option>
                <option value="CC">Chair Car (CC)</option>
                <option value="EC">Exec. Chair Car (EC)</option>
                <option value="2S">Second Class Seats (2S)</option>
              </select>
            </div>
          </div>
          <div className='rail_col_1 brt-0'>
            <div className='rail_icon_img'>
              <img className='rail_ic' src='/assets/images/bus/menu.png' alt="flight" />
            </div>
            <div className='rail_icon'>
              <p>Quota</p>
              <select className='rail_curncy'
                name="journeyQuota"
                value={trainSearchParams.journeyQuota}
                onChange={handleChange}
              >
                <option value="GN">GENERAL</option>
                <option value="LD">LADIES</option>
                <option value="SS">LOWER BERTH/SR.CITIZEN</option>
                <option value="PH">PERSON WITH DISABILITY</option>
                <option value="DP">DUTY PASS</option>
                <option value="TQ">TATKAL</option>
                <option value="PT">PREMIUM TATKAL</option>
              </select>
            </div>
          </div>

          <div className='Rooms_Guests_Serch'>
            <button className="Serch" onClick={handleRaiseRequest} type="button">
              Raise Request
            </button>
          </div>
        </div>
      </div>

      {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            <h3>{enquiryMessage}</h3>
            <button
              onClick={() => {
                setShowPopup(false);
                window.location.reload();
              }}
              className="btn btn-primary"
            >
              Ok
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default RailSearch;
